import { Hint } from "@skbkontur/react-ui";
import * as React from "react";

export function DeveloperHint(props: { children: React.ReactNode }): JSX.Element {
    return <Hint text={"Не поддерживается. Если очень надо, поговорите с разработчиком"}>{props.children}</Hint>;
}
